// extracted by mini-css-extract-plugin
export var avatarContainer = "_hm-0";
export var avatarTypingWave = "_hm-i";
export var gray = "_hm-f";
export var green = "_hm-c";
export var icon = "_hm-9";
export var image = "_hm-1";
export var lg = "_hm-6";
export var md = "_hm-5";
export var presenceDot = "_hm-b";
export var red = "_hm-d";
export var sm = "_hm-4";
export var status = "_hm-a";
export var typingDot = "_hm-h";
export var typingPill = "_hm-g";
export var xl = "_hm-7";
export var xs = "_hm-3";
export var xxl = "_hm-8";
export var xxs = "_hm-2";
export var yellow = "_hm-e";